// src/app/services/adpGage.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IIdNameValue, IUda, IUdaTypes, UpdatePayload } from '../models';

export const udaApi = createApi({
  reducerPath: 'udaApi',
  baseQuery,
  endpoints: (builder) => ({
    getUda: builder.query<IUda, number>({
      query: (id) => `/api/v1.0/ahu/user_defined_accessories/${id}`,
    }),
    getUdaTypes: builder.query<IUdaTypes[], void>({
      query: () => `/api/v1.0/master/v1.0.0/ahu/uda_types/`,
    }),
    getUdaPricingMethods: builder.query<IIdNameValue[], void>({
      query: () =>
        `api/v1.0/master/v1.0.0/ahu/user_defined_component_accessory_pricing_methods/`,
    }),
    updateUda: builder.mutation<IUda, UpdatePayload<IUda>>({
      query: ({ id, body, signal }) => ({
        url: `/api/v1.0/ahu/user_defined_accessories/${id}`,
        method: 'PATCH',
        body,
        signal,
      }),
    }),
  }),
});

export const {
  useLazyGetUdaQuery,
  useUpdateUdaMutation,
  useGetUdaTypesQuery,
  useGetUdaPricingMethodsQuery,
} = udaApi;
